<div class="position tool-box">
    <h5 class="title">
        {{ 'mimic-drawing.position' | translate }}
    </h5>
    <div class="position-list tool-list">
        <div
            class="content-wrapper"
            style="cursor: pointer"
            *ngFor="let positionTool of POSITION_TOOL_LIST; index as i; let isLast = last"
            [matTooltip]="positionTool.tooltip | translate"
            (click)="moveElement(positionTool)">
            <mat-icon class="icon" [svgIcon]="positionTool.svgIcon"></mat-icon>
            <p class="position-text">
                {{ TRANSLATE_PREFIX.concat('.', positionTool.name) | translate }}
            </p>
        </div>
    </div>
    <div class="input-container">
        <app-editor-input-text
            [name]="POSITION_X"
            label="x"
            [value]="xPosition"
            [type]="xPosition == MIXED_STRING ? 'text' : 'number'"
            [shouldEmitOnBlur]="true"
            (onInputChange)="handlePositionChange($event)"
            (onInputKeyDown)="validPositionKeyDown($event)"
            [maxValue]="xMax">
        </app-editor-input-text>
        <app-editor-input-text
            [name]="POSITION_Y"
            label="y"
            [value]="yPosition"
            [type]="yPosition == MIXED_STRING ? 'text' : 'number'"
            [shouldEmitOnBlur]="true"
            (onInputChange)="handlePositionChange($event)"
            (onInputKeyDown)="validPositionKeyDown($event)"
            [maxValue]="yMax">
        </app-editor-input-text>
    </div>
</div>
